import {ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FooterComponent} from "../../../shared/components/footer/footer.component";
import {HeaderComponent} from "../../../core/components/header/header.component";
import {I18NextPipe} from "@kokos-i18next";
import {
    RadioEnhancedComponent
} from "../../../shared/components/controls/ui-controls/radio-enhanced/radio-enhanced.component";
import {SectionComponent} from "../../../shared/components/structure/section/section.component";
import {LinkOutComponent} from "../../../shared/components/structure/link-out/link-out.component";
import {HinweisboxComponent} from "../../../shared/components/hinweisbox/hinweisbox.component";
import {Anliegen} from "../../../core/model/anliegen";
import {Dienststelle} from "../../../core/model/dienststelle";
import {PagesEnum} from "../../../core/model/pages.enum";
import {HinweisboxTypeEnum} from "../../../shared/components/hinweisbox/hinweisbox-type.enum";
import {RadioOption} from "../../../shared/components/controls/ui-controls/radio-enhanced/radio-option";
import {NavigationService} from "../../../shared/utils/navigation.service";
import i18next from "i18next";
import {FooterButtonType} from "../../../shared/components/footer/footer-button";
import {NachrichtPayload} from "../../../core/model/nachricht/nachricht";
import {vNiveauEnum} from "../../../core/model/nachricht/vniveau.enum";
import {environment} from "../../../../environments/environment";
import {KinderLeistung} from "../../../core/model/kinder-leistung";
import {RedirectService} from "../../../core/services/redirect.service";


@Component({
    selector: 'kokos-nachricht-prepare-kiwi',
    imports: [
        FooterComponent,
        HeaderComponent,
        I18NextPipe,
        RadioEnhancedComponent,
        SectionComponent,
        LinkOutComponent,
        HinweisboxComponent
    ],
    templateUrl: './nachricht-prepare-kiwi.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class NachrichtPrepareKiwiComponent implements OnInit, OnDestroy {
    @Input() anliegenList: Anliegen[] = [];
    @Input() dienststelle: Dienststelle | null = null;


    @Output() nachrichtPayload = new EventEmitter<NachrichtPayload>();
    @Output() anliegenName = new EventEmitter<string>();


    anliegen: Anliegen | null = null;

    wantsUploadDokumente: boolean | null = null;

    linkKindergeld = environment.linkKindergeld;
    linkKinderzuschlag = environment.linkKinderzuschlag;

    anliegenOptions: RadioOption[] = [];
    dokumenteOptions: RadioOption[]= [];


    protected readonly PagesEnum = PagesEnum;
    protected readonly HinweisboxTypeEnum = HinweisboxTypeEnum;
    protected readonly KinderLeistung = KinderLeistung;

    private readonly nav = inject(NavigationService);
    private readonly redirectService = inject(RedirectService);

    redirectUrl: string;

    private readonly languageChangedHandler = () => {
        this.buildDokumentOptions();
    };

    ngOnInit(): void {
        if (!this.anliegenList?.length) {
            throw new Error('missing anliegen for famka');
        }
        this.redirectUrl = this.redirectService.redirectUrl;
        this.buildAnliegenOptions();
        this.buildDokumentOptions();
        i18next.on('languageChanged', this.languageChangedHandler);
    }

    ngOnDestroy(): void {
        i18next.off('languageChanged', this.languageChangedHandler);
    }

    get forwardButtonConfig() {
        return {
            label: i18next.t('navigation.forward'),
            type: FooterButtonType.forward,
            showArrow: true
        };
    };

    get backButtonConfig() {
        return {
            label: i18next.t('navigation.cancel'),
            type: FooterButtonType.back,
        };
    };


    onAnliegenChanged(anliegenId: string): void {
        this.wantsUploadDokumente = null;
        this.anliegen = this.anliegenList.find(a => a.id == anliegenId) ?? null;
        if (this.anliegen) {
            this.anliegenName.emit(this.anliegen.name);
        }
    }

    onDokumenteOptionChanged(wantsUploadDokumente: boolean): void {
        this.wantsUploadDokumente = wantsUploadDokumente;
    }

    isReadyToProceed(): boolean {
        return this.wantsUploadDokumente === false && !!this.anliegen;
    }

    handleForwardClicked(): void {
        const payload = this.createNachricht();
        if (payload) {
            this.nachrichtPayload.emit(payload);
        }
    }

    handleBackClicked(): void {
        if (this.redirectUrl) {
            this.redirectTo(this.redirectUrl);
        } else {
            this.nav.goTo('/');
        }
    }

    private createNachricht(): NachrichtPayload | null {
        if (!this.anliegen || !this.dienststelle) {
            return null;
        }
        return {
            bezug: this.anliegen.name,
            empfaengerId: this.dienststelle.dienststellenNummer,
            empfaengerName: this.dienststelle.dienststellenName,
            vNiveau: vNiveauEnum.NORMAL
        } as NachrichtPayload;
    }

    private buildAnliegenOptions(): void {
        this.anliegenOptions = this.anliegenList.map(item => ({label: item.name, value: item.id}));
    }

    private buildDokumentOptions(): void {
        this.dokumenteOptions =  [
            {
                label: i18next.t('sendmail.prepare.kiwi.send-message-without-documents'),
                value: false,
            },
            {
                label: i18next.t('sendmail.prepare.kiwi.send-documents'),
                value: true,
            }
        ];
    }

    protected redirectTo(url: string): void {
        globalThis.location.href = url;
    }

}